import { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import workOrderValueAtom from '../atoms/workOrderValueAtom';
import estimateImageAtom from "../atoms/estimateImageAtom";
import myInfoAtom from '../atoms/myInfoAtom';
import axios from 'axios';
import { url } from '../utils/config';
import CreateWorkOrder from './CreateWorkOrder';
import loaderStateAtom from '../atoms/loaderStateAtom';
import { toast } from 'react-toastify';
import PreviewEstimate from './PreviewEstimate';
import appointmentDetailsAtom from '../atoms/appointmentDetailsAtom';
import { calculateBundleCost, calculateMaterialCost, calculateTotalCost, calculateTotalDiscount, calculateTotalFinalCost, calculateTotalTax, calculateTotalTechnicianCost } from "../helper_functions/estimateCalculation"


function ViewWorkOrder({ setShowModal, setReloadAppointment }) {
    const [workOrder, setWorkOrder] = useRecoilState(workOrderValueAtom);
    const [appointmentDetails, setAppointmentDetails] = useRecoilState(appointmentDetailsAtom)
    const [orderState, setOrderState] = useState('create');
    const [myInfo] = useRecoilState(myInfoAtom);
    const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom)
    const [estimateImage, setEstimateImage] = useRecoilState(estimateImageAtom)
    const technicianCost = appointmentDetails.technicianHourlyCost
    const defaultTaxCost = appointmentDetails.taxRatePercent
    const fromatedTaxRate = Number(defaultTaxCost) / 100


    async function createWorkOrder() {
        if (
            workOrder.serviceBundle.data.length === 0 &&
            workOrder.serviceList.data.length === 0 &&
            workOrder.materialList.data.length === 0 &&
            workOrder.otherList.data.length === 0
        ) {
            return toast.warn('Estimate can not be empty', { autoClose: 3000 })
        }

        try {
            setShowLoader(true)
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}`, 'Content-Type': 'multipart/form-data' };

            const totalCost = calculateTotalCost(workOrder.serviceList, workOrder.materialList, workOrder.otherList, workOrder.serviceBundle, technicianCost, fromatedTaxRate)
            const tax = calculateTotalTax(workOrder.materialList, fromatedTaxRate)
            const totalCostFinal = calculateTotalFinalCost(totalCost, tax)
            const totalDiscount = calculateTotalDiscount(workOrder.materialList, workOrder.serviceList, workOrder.serviceBundle)?.toFixed(2) || 0;

            const formData = new FormData();
            formData.append('data', JSON.stringify(workOrder));
            formData.append('booking_id', appointmentDetails.id);
            formData.append('user_id', appointmentDetails.user_id);
            formData.append('materialCost', calculateMaterialCost(workOrder.materialList));
            formData.append('totalCost', totalCost);
            formData.append('tax', tax);
            formData.append('technicianCost', calculateTotalTechnicianCost(workOrder.serviceList, workOrder.materialList, workOrder.otherList, technicianCost));
            formData.append('totalCostFinal', totalCostFinal);
            formData.append('defaultTax', defaultTaxCost);
            formData.append('totalDiscount', totalDiscount);
            formData.append('bundleCost', calculateBundleCost(workOrder.serviceBundle));

            estimateImage.forEach((file, i) => {
                formData.append('images', file); // or `images[]` if expecting array on backend
            });

            const res = await axios.post(url + '/send_estimate', formData, { headers })

            const newWorkOrder = {
                serviceBundle: { data: [], note: '' },
                serviceList: { data: [], note: '' },
                materialList: { data: [], note: '' },
                otherList: { data: [], note: '' },
                technicianCost: technicianCost
            }

            const details = JSON.parse(JSON.stringify(appointmentDetails));
            details.work_estimation = res.data.data;

            setAppointmentDetails(details)
            setWorkOrder(newWorkOrder);
            setShowLoader(false)
            setEstimateImage([])
            setReloadAppointment(prev => !prev)
            toast.success(res?.data?.message, { autoClose: 3000 })

            setShowModal(false)
        } catch (error) {
            setShowLoader(false)
            console.log(error)
            toast.error(error?.response?.data?.message || 'Something went wrong', { autoClose: 3000 })
        }

    }

    return (
        <div>
            {
                orderState === 'create' && <CreateWorkOrder setShowModal={setShowModal} setOrderState={setOrderState} />
            }
            {
                orderState === 'preview' && <PreviewEstimate setOrderState={setOrderState} createWorkOrder={createWorkOrder} />
            }
        </div>
    )
}

export default ViewWorkOrder;